export default {"src":"/_next/static/media/icon-mastercard.5156636a.svg","height":20,"width":31,"blurWidth":0,"blurHeight":0};